// extracted by mini-css-extract-plugin
module.exports = {"container":"_10e1ZuZeu0ilBgFQ47OV3O","block":"iPRJFcdaPCCATxFHIpZml","blockName":"_2bYqDJIFAkpoZTGRf5bEmC","blockValue":"_2Jq0_1agFTJiscrPGXjmud"};